import { render } from "./v-textarea.vue?vue&type=template&id=48aa8c93"
import script from "./v-textarea.vue?vue&type=script&lang=js"
export * from "./v-textarea.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__